// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
    padding-left: 3rem;
    padding-right: 3rem;
}

.btn-outline-primary {
    border: 1px solid #dbc700;
    color: black;
    background: transparent;
}

.btn-outline-primary:hover,
.btn-outline-primary:active {
    background: #dbc700;
    color: white;
}

.header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

label {
    font-weight: bold;
}

.require-label:after {
    content: ' *';
    color: red;
}

.close {
}

.content-header {
    font-style: normal;
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 27px;
    padding: 19px 0px 14px 0px;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbmZpcm0tZXhpdC1wYWdlLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxrQkFBa0I7SUFDbEIsbUJBQW1CO0FBQ3ZCOztBQUVBO0lBQ0kseUJBQXlCO0lBQ3pCLFlBQVk7SUFDWix1QkFBdUI7QUFDM0I7O0FBRUE7O0lBRUksbUJBQW1CO0lBQ25CLFlBQVk7QUFDaEI7O0FBRUE7SUFDSSxhQUFhO0lBQ2IsbUJBQW1CO0lBQ25CLDhCQUE4QjtBQUNsQzs7QUFFQTtJQUNJLGlCQUFpQjtBQUNyQjs7QUFFQTtJQUNJLGFBQWE7SUFDYixVQUFVO0FBQ2Q7O0FBRUE7QUFDQTs7QUFFQTtJQUNJLGtCQUFrQjtJQUNsQixnQkFBZ0I7SUFDaEIsaUJBQWlCO0lBQ2pCLGlCQUFpQjtJQUNqQiwwQkFBMEI7QUFDOUIiLCJmaWxlIjoiY29uZmlybS1leGl0LXBhZ2UuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5idG4ge1xuICAgIHBhZGRpbmctbGVmdDogM3JlbTtcbiAgICBwYWRkaW5nLXJpZ2h0OiAzcmVtO1xufVxuXG4uYnRuLW91dGxpbmUtcHJpbWFyeSB7XG4gICAgYm9yZGVyOiAxcHggc29saWQgI2RiYzcwMDtcbiAgICBjb2xvcjogYmxhY2s7XG4gICAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7XG59XG5cbi5idG4tb3V0bGluZS1wcmltYXJ5OmhvdmVyLFxuLmJ0bi1vdXRsaW5lLXByaW1hcnk6YWN0aXZlIHtcbiAgICBiYWNrZ3JvdW5kOiAjZGJjNzAwO1xuICAgIGNvbG9yOiB3aGl0ZTtcbn1cblxuLmhlYWRlci1jb250ZW50IHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xufVxuXG5sYWJlbCB7XG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG59XG5cbi5yZXF1aXJlLWxhYmVsOmFmdGVyIHtcbiAgICBjb250ZW50OiAnIConO1xuICAgIGNvbG9yOiByZWQ7XG59XG5cbi5jbG9zZSB7XG59XG5cbi5jb250ZW50LWhlYWRlciB7XG4gICAgZm9udC1zdHlsZTogbm9ybWFsO1xuICAgIGZvbnQtd2VpZ2h0OiA2MDA7XG4gICAgZm9udC1zaXplOiAxLjJyZW07XG4gICAgbGluZS1oZWlnaHQ6IDI3cHg7XG4gICAgcGFkZGluZzogMTlweCAwcHggMTRweCAwcHg7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/team/components/confirm-exit-page/confirm-exit-page.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;AACA;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA,ogDAAogD","sourcesContent":[".btn {\n    padding-left: 3rem;\n    padding-right: 3rem;\n}\n\n.btn-outline-primary {\n    border: 1px solid #dbc700;\n    color: black;\n    background: transparent;\n}\n\n.btn-outline-primary:hover,\n.btn-outline-primary:active {\n    background: #dbc700;\n    color: white;\n}\n\n.header-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\nlabel {\n    font-weight: bold;\n}\n\n.require-label:after {\n    content: ' *';\n    color: red;\n}\n\n.close {\n}\n\n.content-header {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 1.2rem;\n    line-height: 27px;\n    padding: 19px 0px 14px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
